module.exports = __webpack_public_path__ + "assets/5fb472367321786216a4a58b78a2c74d.mp3";